import type { Role } from '@ambec/shared';

/**
 * Selector de modo para el DUEÑO / administrador (2026-08-11): al entrar, un admin elige si opera
 * como Administrador (área de gestión) o como Usuario (la experiencia del cliente). El rol REAL en
 * el backend sigue siendo admin; esto solo decide qué interfaz se muestra. Se pregunta en cada login.
 */
export function SelectorModo({ nombre, onElegir }: { nombre?: string | null; onElegir: (r: Role) => void }) {
  const primerNombre = (nombre || '').trim().split(/\s+/)[0];
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-gradient-to-b from-white to-[#eef4fc] px-6">
      <div className="w-full max-w-lg text-center">
        <h1 className="text-2xl font-semibold tracking-tight text-azul-noche">
          {primerNombre ? `Hola, ${primerNombre}` : 'Bienvenido'}
        </h1>
        <p className="mt-1.5 text-sm font-light text-gris">¿Cómo quieres entrar hoy?</p>

        <div className="mt-7 grid gap-4 sm:grid-cols-2">
          <button
            type="button"
            onClick={() => onElegir('admin')}
            className="group flex flex-col items-center gap-2 rounded-2xl border border-[#e6eef8] bg-white p-6 text-center shadow-sm transition-all hover:-translate-y-0.5 hover:border-azul-profundo/40 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-azul-profundo"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-azul-profundo/10 text-azul-profundo" aria-hidden="true">
              <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z"/></svg>
            </span>
            <span className="text-[15px] font-semibold text-azul-noche">Administrador</span>
            <span className="text-[12px] font-light leading-snug text-gris">Gestión de la plataforma: usuarios, conectores LLM, agentes y observabilidad.</span>
          </button>

          <button
            type="button"
            onClick={() => onElegir('user')}
            className="group flex flex-col items-center gap-2 rounded-2xl border border-[#e6eef8] bg-white p-6 text-center shadow-sm transition-all hover:-translate-y-0.5 hover:border-azul-profundo/40 hover:shadow-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-azul-profundo"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-azul-profundo/10 text-azul-profundo" aria-hidden="true">
              <svg viewBox="0 0 24 24" className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </span>
            <span className="text-[15px] font-semibold text-azul-noche">Usuario</span>
            <span className="text-[12px] font-light leading-snug text-gris">La experiencia del cliente: el panel y los agentes (DIA, Newsletter, etc.).</span>
          </button>
        </div>

        <p className="mt-6 text-[11px] font-light text-gris/80">Podrás cambiar de vista cuando quieras desde el menú superior.</p>
      </div>
    </div>
  );
}
